import { render, staticRenderFns } from "./ServicesSwitcherPopup.vue?vue&type=template&id=5b4fb37e&scoped=true&"
import script from "./ServicesSwitcherPopup.vue?vue&type=script&lang=js&"
export * from "./ServicesSwitcherPopup.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSwitcherPopup.vue?vue&type=style&index=0&id=5b4fb37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4fb37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4fb37e')) {
      api.createRecord('5b4fb37e', component.options)
    } else {
      api.reload('5b4fb37e', component.options)
    }
    module.hot.accept("./ServicesSwitcherPopup.vue?vue&type=template&id=5b4fb37e&scoped=true&", function () {
      api.rerender('5b4fb37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/ServicesSwitcherPopup.vue"
export default component.exports